import { memo, useSyncExternalStore } from 'react';
import { useImageOverlay } from './useImageOverlay';
import { timelineActionsStore } from '../../ClipNewTimeline/store/timelineActions';
import FilesInput from '@/components/atoms/inputs/FilesInput/FilesInput';

const ImageOverlay = ({ onUploadComplete }: { onUploadComplete: () => void }) => {
  const { isAddingImage } = useSyncExternalStore(timelineActionsStore.subscribe, timelineActionsStore.getSnapshot);
  const { uploadImage, acceptedFormats } = useImageOverlay({ onUploadComplete });

  return (
    <FilesInput
      onFilesUpload={uploadImage}
      accept={acceptedFormats}
      title={isAddingImage ? 'Uploading...' : 'Upload Image'}
      variant="button"
      multiple={false}
      iconClassNames={isAddingImage ? 'animate-spin' : ''}
      icon={isAddingImage ? 'IconLoader2' : 'IconUpload'}
      isDisabled={isAddingImage}
    />
  );
};

export default memo(ImageOverlay);
